import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../payment/payment.css";
import Address from "./Address";
import PayForm from "./PayForm";
import PaymentItem from "./PaymentItem";
import { toast } from "react-hot-toast";
import { removeBasketItems } from "../../redux/feature/cartReducer";
import { cityData } from "../../assets/data";
import { clickPaymentButton } from "../../redux/feature/paymentReducer";
import PaymentModal from "./PaymentModal";

const Payment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [emptyDisplayNone, setEmptyDisplayNone] = useState(false);

  //! Address States
  const [fullname, setFullname] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [city, setCity] = useState("");
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [address, setAddress] = useState("");

  //! Payform States
  const [payFormFullname, setPayFormFullname] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [expiryDateCheck, setExpiryDateCheck] = useState(null);
  const [cvvNumber, setCvvNumber] = useState("");
  const [focused, setFocused] = useState(false);
  const [isConfirmedPaymentForm, setIsConfirmedPaymentForm] = useState(false);

  const [paymentModal, setPaymentModal] = useState(false);

  const cartItems = useSelector((state) => state.cart.itemsList);
  const itemsList = useSelector((state) => state.cart.itemsList);

  //! City Name Data
  const normalizedInput = city.toLocaleUpperCase("tr-TR");
  const cityDataBoolean = cityData
    .map((item) => item.il_adi.toLocaleUpperCase("tr-TR"))
    .includes(normalizedInput);

  //! Submit Forms
  useEffect(() => {
    if (isConfirmed && isConfirmedPaymentForm) {
      setLoading(true);
      setEmptyDisplayNone(true);
      dispatch(clickPaymentButton(false));
      setTimeout(() => {
        setPayFormFullname("");
        setExpiryDate("");
        setCvvNumber("");
        setCardNumber("");
        dispatch(removeBasketItems());
        setLoading(false);
        setPaymentModal(true);
      }, 3500);
    }
  }, [isConfirmed, isConfirmedPaymentForm]);

  //! Address Form Confirm
  const handleConfirm = (e) => {
    e.preventDefault();
    if (fullname.length < 4) {
      toast("Please check your fullname", {
        style: {
          background: "#711b1b",
          color: "#fff",
          fontSize: ".75rem",
          textTransform: "uppercase",
        },
      });
    } else if (phoneNumber.length < 15) {
      toast("Please check your phone number", {
        style: {
          background: "#711b1b",
          color: "#fff",
          fontSize: ".75rem",
          textTransform: "uppercase",
        },
      });
    } else if (!cityDataBoolean) {
      e.preventDefault();
      toast("Please check the City", {
        style: {
          background: "#711b1b",
          color: "#fff",
          fontSize: ".75rem",
          textTransform: "uppercase",
        },
      });
    } else if (address.length < 15) {
      toast("Please check the Address", {
        style: {
          background: "#711b1b",
          color: "#fff",
          fontSize: ".75rem",
          textTransform: "uppercase",
        },
      });
    } else {
      setIsConfirmed(true);
    }
  };

  //! Payment Form Confirm
  const handleConfirmPaymentForm = (e) => {
    e.preventDefault();
    if (payFormFullname.length < 4) {
      toast("Please Check Your Card Holder Fullname", {
        style: {
          background: "#711b1b",
          color: "#fff",
          fontSize: ".75rem",
          textTransform: "uppercase",
        },
      });
    } else if (cardNumber.length < 19) {
      toast("Please check your card number", {
        style: {
          background: "#711b1b",
          color: "#fff",
          fontSize: ".75rem",
          textTransform: "uppercase",
        },
      });
    } else if (!expiryDateCheck || expiryDate.length < 5) {
      toast("Please check your expiry date", {
        style: {
          background: "#711b1b",
          color: "#fff",
          fontSize: ".75rem",
          textTransform: "uppercase",
        },
      });
    } else if (cvvNumber.length < 3) {
      toast("Please check your cvv number", {
        style: {
          background: "#711b1b",
          color: "#fff",
          fontSize: ".75rem",
          textTransform: "uppercase",
        },
      });
    } else {
      setIsConfirmedPaymentForm(true);
    }
  };

  //! Address Form Edit
  const handleEdit = (e) => {
    e.preventDefault();
    setIsConfirmed(false);
  };

  //! Payment Form Edit
  const handleEditPayform = (e) => {
    e.preventDefault();
    setIsConfirmedPaymentForm(false);
  };

  //! When the payment modal opens -
  //! scroll to the top of the page
  useEffect(() => {
    if (paymentModal) {
      window.scrollTo(0, 0);
    }
  }, [paymentModal]);

  //! Basket Total Price
  let total = 0;
  itemsList.forEach((item) => {
    total += item.totalPrice;
  });

  //! Ensuring that only strings are entered into the input
  const handleAddressCityChangeString = (event) => {
    const { value } = event.target;
    // Gelen değer içinde sadece harf karakterleri olup olmadığını kontrol ediyoruz
    const onlyLetters = /^[A-Za-zğüşıöçĞÜŞİÖÇ\s]+$/;
    if (value === "" || onlyLetters.test(value)) {
      setCity(value);
    }
  };

  const handleClickCheckButton = () => {
    setLoading(true);
    setEmptyDisplayNone(false);
    setTimeout(() => {
      setLoading(false);
      navigate("/");
      dispatch(clickPaymentButton(false));
    }, 1000);
  };

  const handleBackHome = () => {
    setLoading(true);
    setTimeout(() => {
      navigate("/");
      dispatch(clickPaymentButton(false));
    }, 800);
  };

  return (
    <>
      {loading && (
        <div className="loading-gif">
          <span className="loader"></span>
        </div>
      )}
      {paymentModal ? (
        <PaymentModal
          fullname={fullname}
          address={address}
          handleClickCheckButton={handleClickCheckButton}
        />
      ) : (
        <div className="payment container">
          {cartItems.length < 1 ? (
            <div className="empty-list">
              <h6 className={`${emptyDisplayNone ? "d-none" : ""}`}>
                Shopping List is Empty
              </h6>
              <button
                className={`${emptyDisplayNone ? "d-none" : "back-home"}`}
                onClick={handleBackHome}
              >
                Back Home
              </button>
            </div>
          ) : (
            <>
              <div className="pay-page d-flex justify-content-center align-items-center flex-wrap text-center">
                <Address
                  fullname={fullname}
                  payFormFullname={payFormFullname}
                  setFullname={setFullname}
                  phoneNumber={phoneNumber}
                  setPhoneNumber={setPhoneNumber}
                  city={city}
                  setCity={setCity}
                  address={address}
                  setAddress={setAddress}
                  cityDataBoolean={cityDataBoolean}
                  isConfirmed={isConfirmed}
                  setIsConfirmed={setIsConfirmed}
                  handleConfirm={handleConfirm}
                  handleEdit={handleEdit}
                  handleAddressCityChangeString={handleAddressCityChangeString}
                  isConfirmedPaymentForm={isConfirmedPaymentForm}
                />
                <PayForm
                  payFormFullname={payFormFullname}
                  setPayFormFullname={setPayFormFullname}
                  cardNumber={cardNumber}
                  setCardNumber={setCardNumber}
                  expiryDate={expiryDate}
                  setExpiryDate={setExpiryDate}
                  cvvNumber={cvvNumber}
                  setCvvNumber={setCvvNumber}
                  focused={focused}
                  setFocused={setFocused}
                  handleConfirmPaymentForm={handleConfirmPaymentForm}
                  isConfirmed={isConfirmed}
                  expiryDateCheck={expiryDateCheck}
                  setExpiryDateCheck={setExpiryDateCheck}
                  isConfirmedPaymentForm={isConfirmedPaymentForm}
                  handleEditPayform={handleEditPayform}
                />
                <div className="payment-items">
                  <div className="payment-items-title">
                    Products Added to Cart
                  </div>
                  {cartItems?.map((item) => (
                    <PaymentItem
                      key={item.id}
                      id={item.id}
                      image={item.image}
                      title={item.title}
                      price={item.price}
                      quantity={item.quantity}
                      totalPrice={item.totalPrice}
                    />
                  ))}
                  {total > 0 && total <= 100 && (
                    <div className="payment-total-div">
                      <div className="shipping-cost">
                        Shipping Cost
                        <span className="ms-3">$9.99</span>
                      </div>
                      <div className="payment-total-price">
                        <h6>
                          Total Price
                          <span className="ms-3">
                            ${(total + 9.99).toFixed(2)}
                          </span>
                        </h6>
                      </div>
                    </div>
                  )}

                  {total > 100 && (
                    <div className="payment-total-div">
                      <div className="shipping-cost text-decoration-line-through">
                        Shipping Cost
                        <span className="ms-3">$9.99</span>
                      </div>
                      <div className="payment-total-price">
                        <h6>
                          Total Price
                          <span className="ms-3">${total?.toFixed(2)}</span>
                        </h6>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default Payment;
